module.exports = __webpack_public_path__ + "img/ai_speakingM.35ef9332.png";